export const INITIALIZE_PLANS = "plan_loader/INITIALIZE_PLANS";
export const SET_IS_LOADING_PLANS = "plan_loader/SET_IS_LOADING_PLANS";
export const REQUEST_PLANS = "plan_loader/REQUEST_PLANS";
export const RECEIVE_PLANS = "plan_loader/RECEIVE_PLANS";
export const REQUEST_PRICING = "plan_loader/REQUEST_PRICING";
export const RECEIVE_PRICING = "plan_loader/RECEIVE_PRICING";
export const initializePlans = (companyIDToken) => ({
  type: INITIALIZE_PLANS,
  payload: {
    companyIDToken,
  },
});
export const setIsLoadingPlans = (isLoading) => ({
  type: SET_IS_LOADING_PLANS,
  isLoading,
});
export const requestPlans = (companyIDToken) => ({
  type: REQUEST_PLANS,
  payload: {
    companyIDToken,
  },
});
export const receivePlans = (plans) => ({
  type: RECEIVE_PLANS,
  plans,
});
export const requestPricing = () => ({
  type: REQUEST_PRICING,
});
export const receivePricing = ({ planIDs, averageMonthlyPremiums, employeeCosts, totalCosts }) => ({
  type: RECEIVE_PRICING,
  planIDs,
  averageMonthlyPremiums,
  employeeCosts,
  totalCosts,
});
